export default {
    entity: 'Pleo Technologies A/S (36538686) and Pleo Financial Services A/S (39155435)',
    address: {
        richText: [
            {
                type: 'paragraph',
                text: 'Ravnsborg Tværgade 5C 2200 Copenhagen N Denmark',
                spans: [],
            },
        ],
    },
    terms_body:
        'The Pleo Card is issued by Pleo Financial Services A/S pursuant to a license from Mastercard International Incorporated. Mastercard and the Mastercard Brand Mark are registered trademarks of Mastercard International Incorporated. Pleo Financial Services A/S is a regulated Electronic Money Institution, authorised by the Financial Supervisory Authority, Denmark. Registered Office of Pleo Financial Services A/S: Ravnsborg Tværgade 5 C, 4. Copenhagen N, 2200, Denmark. CVR Number: 39155435. All communications should be sent to Pleo Technologies A/S, Ravnsborg Tværgade 5C, 2200 Copenhagen N, Denmark',
    copyright_text: 'All rights reserved',
    financial_partner_terms_text: {
        richText: [],
    },
    financial_partner_copyright_text: null,
    contact_us: 'Chat with us',
    sales_email: null,
    info_email: null,
    support_email: null,
    product_heading: 'Product',
    resources_heading: 'Resources',
    company_heading: 'Company',
    legal_heading: 'Legal',
    solutions_heading: 'Solutions',
    partnerships_heading: null,
    product_links: [
        {
            text: 'Status',
            link: {
                link_type: 'Web',
                uid: null,
                type: null,
                lang: null,
                target: null,
                url: 'https://status.pleo.io/',
            },
        },
    ],
    resources_links: [
        {
            text: 'Help Centre',
            link: {
                link_type: 'Web',
                uid: null,
                type: null,
                lang: null,
                target: null,
                url: 'https://help.pleo.io/en/',
            },
        },
        {
            text: 'Developers',
            link: {
                link_type: 'Web',
                uid: null,
                type: null,
                lang: null,
                target: null,
                url: 'https://developers.pleo.io/reference/introduction',
            },
        },
    ],
    company_links: [
        {
            text: 'Careers',
            link: {
                link_type: 'Web',
                uid: null,
                type: null,
                lang: null,
                target: null,
                url: 'https://www.pleo.io/en/careers',
            },
        },
        {
            text: 'Legal',
            link: {
                link_type: 'Web',
                uid: null,
                type: null,
                lang: null,
                target: null,
                url: '/pt/legal',
            },
        },
    ],
    legal_links: [
        {
            text: 'Master Service Agreement',
            link: {
                link_type: 'Web',
                uid: null,
                type: null,
                lang: null,
                target: null,
                url: 'https://www.pleo.io/legal-documents/pleo-master-service-agreement-eea-eu.pdf',
            },
        },
        {
            text: 'Privacy Policy',
            link: {
                link_type: 'Web',
                uid: null,
                type: null,
                lang: null,
                target: null,
                url: 'https://www.pleo.io/legal-documents/pleo-privacy-policy-en.pdf',
            },
        },
        {
            text: 'Fraud awareness',
            link: {
                link_type: 'Web',
                uid: null,
                type: null,
                lang: null,
                target: null,
                url: 'https://www.pleo.io/legal-documents/pleo-fraud-awereness-en.pdf',
            },
        },
        {
            text: 'Complaints process',
            link: {
                link_type: 'Web',
                uid: null,
                type: null,
                lang: null,
                target: null,
                url: 'https://www.pleo.io/legal-documents/pleo-complaint-process-en.pdf',
            },
        },
        {
            text: 'Code of Conduct',
            link: {
                link_type: 'Web',
                uid: null,
                type: null,
                lang: null,
                target: null,
                url: 'https://www.pleo.io/en/code-of-conduct',
            },
        },
    ],
    solutions_links: [],
    partnerships_links: [],
} as any
